import type { FC } from 'react'
import type { GetShopItems_getShopItems_lootRewardPackage_lootRewards } from '@g4g/graphql/src/shop/__generated__/GetShopItems'
import type { CartProduct } from '../../shopping-cart/provider/types'
import { calculateRewardTotals } from '@/shop/src/utils/shopItemUtils'
import RewardList from '../rewards/RewardList'
import { classNames } from '@g4g/utils/src/react/class-names'

const Clarifications: FC<{
  loot: GetShopItems_getShopItems_lootRewardPackage_lootRewards[]
  alignLeft?: boolean
}> = ({ loot, alignLeft }) => {
  const clarifications = loot.filter((l) => l.clarification).map((l) => l.clarification)

  return (
    <>
      {clarifications.length > 0 && (
        <div
          data-cy="shop-loot-reward-clarifications"
          className={classNames(
            'flex flex-col px-0.5',
            alignLeft ? 'justify-start items-start' : 'justify-end items-end'
          )}
        >
          {clarifications.map(
            (c, i) =>
              c && (
                <div className="text-sm text-white/80" key={i}>
                  {'* '}
                  {c}
                </div>
              )
          )}
        </div>
      )}
    </>
  )
}

const ProductRewards: FC<{
  product: CartProduct
  shine?: boolean
  alignLeft?: boolean
  omitVipExpAndSpReward?: boolean
}> = ({ product, shine, alignLeft, omitVipExpAndSpReward }) => {
  const loot = calculateRewardTotals([product]).loot

  return (
    <div
      className={classNames(
        'flex flex-col w-full space-y-1',
        alignLeft ? 'justify-start' : 'justify-end'
      )}
    >
      <RewardList
        omitVipExpAndSpReward={omitVipExpAndSpReward}
        loot={loot}
        shine={shine}
        alignmentClass={alignLeft ? 'justify-start' : 'justify-end'}
      />
      <Clarifications loot={loot} alignLeft={alignLeft} />
    </div>
  )
}

export default ProductRewards
